import React, { useContext, useState, useEffect } from 'react';
import './login.css';
import { session_status, VerifyLoginCredential } from '../../Services/Login/LoginApi';
import { AuthContext, LoaderContext } from '../../Context/ContextProvider';
import { useLocation, useNavigate } from 'react-router-dom';
import loginBackgroundImage from '../../Assets/Images/loginBackgroundImage.jpg';
import google from '../../Assets/Images/google.png';
import GoogleLoginButton from './GoogleLoginButton';
import { captureEventsLogin, clearEventsLogin, getEventsLogin, resumeEventsLogin } from '../../utils/eventsLogin';
const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  useState(() => captureEventsLogin());
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [CustomError, setCustomError] = useState('');
  const [passwordVisible, setPasswordVisible] = useState(false);
  const { setLoginItem, setUserRole } = useContext(AuthContext);
  const { setLoader } = useContext(LoaderContext);
  const [rememberMe, setRememberMe] = useState(false);
  const getRedirectPath = () => {
    const redirect = new URLSearchParams(location.search).get('redirect');
    if (redirect && redirect.startsWith('/') && !redirect.startsWith('//')) {
      return redirect;
    }
    return null;
  };
  const redirectAfterLogin = role => {
    if (resumeEventsLogin()) return;
    const redirectPath = getRedirectPath();
    if (role === 'employer') {
      navigate('/employer/dashboard', { replace: true });
      return;
    }
    if (role === 'admin') {
      navigate('/admin-dashboard', { replace: true });
      return;
    }
    if (redirectPath) {
      window.location.replace(redirectPath);
      return;
    }
    navigate('/', { replace: true });
  };

  useEffect(() => {
    if (localStorage.getItem('remember') === 'true') {
      setEmail(JSON.parse(localStorage.getItem('rememberedEmail')));
      setPassword(JSON.parse(localStorage.getItem('rememberedPassword')));
      setRememberMe(true);
    }
    session_status_data();
  }, []);

  const session_status_data = async () => {
    try {
      const loginSnapshot = localStorage.getItem('login');
      const data = await session_status();
      // A newer password/Google login must not be overwritten by a late session probe.
      if (localStorage.getItem('login') !== loginSnapshot) return;
      // If no user is logged in
      if (data.user_type === 'none' || data.user_type === undefined) {
        localStorage.removeItem('login');
        setLoginItem(null); // Optionally reset in state
        setUserRole(null); // Optionally reset role
        return; // Exit early
      }

      console.log('session_status_data - data.user_type:', data.user_type);
      let message = undefined;
      let userRole = ''; // Define userRole here

      switch (data.user_type) {
        case 'organization':
          message = 'Logged in successfully as School';
          userRole = 'organization'; // Set userRole
          break;
        case 'student':
          message = 'Logged in successfully as Student';
          userRole = 'student_registered'; // Set userRole
          break;
        case 'seeker':
          message = 'Logged in successfully as Seeker';
          userRole = 'seeker'; // Set userRole
          break;
        case 'employer': // New case for employer
          message = 'Logged in successfully as Employer';
          userRole = 'employer'; // Set userRole
          break;
        case 'admin':
          message = 'Logged in successfully';
          userRole = 'admin';
          break;
        default:
          localStorage.removeItem('login');
          setLoginItem(null); // Optionally reset in state
          setUserRole(null); // Optionally reset role
          navigate(`/login${location.search}`, { replace: true });
          return;
      }
      console.log('session_status_data - userRole:', userRole);
      if (message === undefined) {
        navigate(`/login${location.search}`, { replace: true });
        return;
      }
      const loginData = {
        message,
        role: userRole, // Use the determined userRole
      };

      setUserRole(userRole); // Use the determined userRole
      localStorage.setItem('login', JSON.stringify(loginData));
      setLoginItem(loginData);
      redirectAfterLogin(userRole);
    } catch (error) {
      console.error('Session status error:', error);
      // optionally show error toast or redirect
    }
  };

  const handleRememberMeChange = () => {
    setRememberMe(!rememberMe);
  };

  const handleLogin = async () => {
    if (rememberMe) {
      localStorage.setItem('rememberedEmail', JSON.stringify(email));
      localStorage.setItem('rememberedPassword', JSON.stringify(password));
      localStorage.setItem('remember', true);
    } else {
      localStorage.removeItem('rememberedEmail');
      localStorage.removeItem('rememberedPassword');
      localStorage.removeItem('remember');
    }
    // Clear browser cookies for credentials
    if (email === null || email === undefined || email === '' || password === null || password === undefined || password === '') {
      setError('Field is required ');
      return;
    }
    //  else if ((email !== null || email !== undefined || email !== "") && !isValidEmail(email)) {
    //     setError('Invalid Email')
    //     return
    // }
    await clearCredentialCookies();

    setLoader(true);
    try {
      const remember_me = rememberMe;
      // Normal login flow
      const response = await VerifyLoginCredential({ email, password, remember_me });

      if (!response?.code?.includes('ERR')) {
        setLoader(false);
        setError('');
        console.log('handleLogin - response.message:', response.message);

        let role = '';
        switch (response.message) {
          case 'Logged in successfully as School':
            role = 'organization';
            break;
          case 'Logged in successfully as student':
            role = 'student_registered';
            break;
          case 'Registration incomplete':
            role = 'student_unregistered';
            break;
          case 'Logged in successfully as Seeker':
            role = 'seeker';
            break;
          case 'Logged in successfully as Employer': // New case for employer
            role = 'employer';
            break;
          case 'Logged in successfully (Google) as student':
            role = 'student_unregistered';
            break;
          case 'Logged in successfully (Google) as Seeker':
            role = 'seeker';
            break;
          case 'Logged in successfully':
            if (response.admin) {
              role = 'admin';
            } else {
              role = '';
            }
            break;
          default:
            role = '';
        }
        console.log('handleLogin - role:', role);
        if (response.message === 'Registration incomplete' && !getEventsLogin()) {
          let seekerId = null;
          let userType = null;
          let name = null;

          if (response.student?.id) {
            seekerId = response.student.id;
            name = response.student.name;
            userType = 'student';
          } else if (response.seeker?.id) {
            seekerId = response.seeker.id;
            name = response.seeker.name;
            userType = 'seeker';
          }

          if (seekerId && userType) {
            localStorage.removeItem('SSOProvider');
            localStorage.setItem('Type', userType); // Save either "student" or "seeker"
            navigate(`/sign-up?step=2&id=${seekerId}&name=${name}`);
          } else {
            console.warn('No seeker or student ID found in response.');
          }

          return;
        }

        const loginData = {
          ...response,
          role,
          is_sso: false,
          provider: 'email',
        };

        setUserRole(role);
        localStorage.setItem('login', JSON.stringify(loginData));
        setLoginItem(loginData);
        redirectAfterLogin(role);
      } else {
        setLoader(false);
        setCustomError(response?.response?.data?.message || response?.message || 'Login failed');
        // Keep the original return URL when showing the login form again after
        // an unsuccessful attempt.
        navigate(`/login${location.search}`, { replace: true });
      }
    } catch (err) {
      setLoader(false);
      setCustomError('Something went wrong. Please try again.');
    }
  };

  // Function to clear specific cookies
  const clearCredentialCookies = () => {
    const cookies = document.cookie.split('; ');
    cookies.forEach(cookie => {
      const cookieName = cookie.split('=')[0].trim();
      // Delete cookies related to authentication or any cookie containing 'Id'
      if (
        cookieName === 'authToken' ||
        cookieName === 'userEmail' ||
        cookieName === 'sessionId' ||
        cookieName === 'student_Id' ||
        cookieName.includes('Id')
      ) {
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      }
    });
  };
  function isValidEmail(email) {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
    return regex.test(email);
  }

  return (
    <div class="signup-wrapper">
      <div class="signup-card">
        <div class="signup-left">
          <img src={loginBackgroundImage} alt="Sign Up Visual" />
          <div class="info-cards">
            <div class="info-card">
              <span class="info-card-value">2x</span>
              <br />
              <span class="info-card-label">Job Matches</span>
            </div>
            <div class="info-card">
              <span class="info-card-value"> 50%</span>
              <br />
              <span class="info-card-label">Time Saving in Job Searches</span>
            </div>
            <div class="info-card">
              <span class="info-card-value"> 95%</span>
              <br />
              <span class="info-card-label">Score on mostly all ATS</span>
            </div>
            <div class="info-card">
              <span class="info-card-value"> 50%</span>
              <br />
              <span class="info-card-label">More Interview Invites</span>
            </div>
          </div>
        </div>

        <div class="signup-right">
          <h2 class="welcome-heading" onClick={() => navigate('/')}>
            Welcome back to
            <img src={`${process.env.PUBLIC_URL}/assets/images/logo/SeekJobsLog1.png`} alt="SeekJobs" class="inline-logo" />
          </h2>
          <h3 className="HeadingFont">New jobs are waiting!</h3>

          <div style={{ marginTop: '20px' }}>
            <GoogleLoginButton text={'Log In with Google'} />
          </div>

          <div class="divider" style={{ margin: '20px 0' }}>
            Or
          </div>

          <form class="signup-form" onSubmit={(e) => { e.preventDefault(); handleLogin(); }}>
            <div class="form-group-login">
              <label className="login-label" for="email">
                Email Address
              </label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value.replace(/\s/g, ''))}
                onKeyDown={e => {
                  if (e.key === ' ') {
                    e.preventDefault();
                  }
                }}
                placeholder="Enter your email"
              />

              {error && (email === null || email === undefined || email === '') ? (
                <div className="text-danger text-start"> {error}</div>
              ) : error && (email !== null || email !== undefined || email !== '') && !isValidEmail(email) ? (
                <div className="text-danger text-start">Invalid Email</div>
              ) : (
                ''
              )}
            </div>

            <div className="form-group-login">
              <label className="login-label" htmlFor="password">
                Password
              </label>

              <div className="password-wrapper">
                <input
                  type={passwordVisible ? 'text' : 'password'}
                  id="password"
                  name="password"
                  placeholder="Enter your password"
                  className="password-input"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                />
                <span className="toggle-password" onClick={() => setPasswordVisible(!passwordVisible)}>
                  {!passwordVisible ? <i className="fas fa-eye-slash"></i> : <i className="fas fa-eye"></i>}
                </span>
              </div>
              {error && (password === null || password === undefined || password === '') ? (
                <div className="text-danger text-start"> {error}</div>
              ) : (
                ''
              )}
              {(CustomError !== null || CustomError !== undefined || CustomError !== '') && (
                <div className="text-danger text-start"> {CustomError}</div>
              )}
              <div className="password-options">
                <label className="remember-me" style={{ cursor: 'pointer' }}>
                  <input type="checkbox" checked={rememberMe} onChange={handleRememberMeChange} /> Remember Me
                </label>
                <a onClick={() => { clearEventsLogin(); navigate('/forget-password'); }} style={{ cursor: 'pointer' }} className="forgot-password">
                  Forgot Password?
                </a>
              </div>
            </div>

            <button type="submit" class="primary-btn" style={{ cursor: 'pointer', marginTop: '2px' }}>
              Log in
            </button>
            <button type="button" onClick={() => { clearEventsLogin(); navigate('/sign-up'); }} class="primary-btn main-second" style={{ cursor: 'pointer' }}>
              Don't have an account? Sign up
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
